<div class="modal-header">
  <h4 class="modal-title">
    what are you looking for ?
  </h4>
  <a href="javascript:void(0)" style="color: black;" data-dismiss="modal">
    <i class="fa fa-times" aria-hidden="true"></i>
  </a>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <form [formGroup]="GetADealForm" #dFrm="ngForm">
        <div class="row cWebcardPopup">
          <div class="col-md-7">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>Remarks*</h5>
                  <textarea class="form-control" formControlName="Remarks"></textarea>
                  <span *ngIf="dFrm.submitted && dForm.Remarks.errors" class="text-danger">
                    <span *ngIf="dForm.Remarks.errors.required"> *required</span>
                  </span>
                </div>
                <div class="form-group">
                  <h5>Preferred Contact Mode</h5>
                  <select class="form-control" formControlName="PreferredContactMode">
                    <option *ngFor="let item of ContactModeList" [value]="item.DataValue">{{item.Column1}}</option>
                  </select>
                  <span *ngIf="dFrm.submitted && dForm.PreferredContactMode.errors" class="text-danger">
                    <span *ngIf="dForm.PreferredContactMode.errors.required"> *required</span>
                  </span>
                </div>
                <div class="form-group">
                  <h5>Best time to contact you?</h5>
                  <select class="form-control" formControlName="BestTimeToCall">
                    <option *ngFor="let item of TimeRangeList" [value]="item.DataValue">{{item.Column1}}</option>
                  </select>
                  <span *ngIf="dFrm.submitted && dForm.BestTimeToCall.errors" class="text-danger">
                    <span *ngIf="dForm.BestTimeToCall.errors.required"> *required</span>
                  </span>
                </div>
                <div class="form-group">
                  <h5>Your address (optional)</h5>
                  <textarea class="form-control" formControlName="LocationOfService"></textarea>
                  <span *ngIf="dFrm.submitted && dForm.LocationOfService.errors" class="text-danger">
                    <span *ngIf="dForm.LocationOfService.errors.required"> *required</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="!UserLoggedIn">
              <div class="col-md-12">
                <app-visitor-handler [CountryID]="WebSiteMetaData.COUNTRYID" [PortalID]="WebSiteMetaData.PID" [PortalName]="WebSiteMetaData.PC" (visitorLoggedIn)="CheckUserLoggedIn();Emit();"></app-visitor-handler>
              </div> 
            </div>
            <div class="row" [hidden]="!UserLoggedIn">
              <div class="col-md-12">
                <div id="enquiryForm" class="cManikgreCaptcha"></div>
                <span *ngIf="CaptchaInvalid" class="text-danger">
                  <span> {{CaptchaMessage}}</span>
                </span>
              </div>
            </div>
            <div class="row cWebcardPopupAction" *ngIf="ShowButton" >
              <div class="col-md-12">
                <label id="lblGMessage" style="display: none;" class="alert alert-info"></label>
                <button type="submit" class="btn btn-primary cWebcardSubmit" *ngIf="!GDModel.IsSubmitted"
                        (click)="SubmitForm();">
                  Submit
                </button>
                <button class="btn btn-primary cWebcardSubmitLoader" *ngIf="GDModel.IsSubmitted">
                  <manik-button-loader></manik-button-loader>
                </button>
                <button type="button" id="btnClose" class="btn btn-danger cWebcardCancel" (click)="close();" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-12">
                <div class="cWebcardPopupInstruction">
                  <h4>Please tell us about your requirements and we will try to get you the best deals.</h4>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="cWebcardPopupHeader">
                  <h4>HOW IT WORKS!</h4>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="cWebcardPopupParagraph">
                  <img id="iRequirements" src=" https://dkzxkcjlbnjui.cloudfront.net/webcard/popup/icon/webcardpopupicon1.png" />
                  <p>Fill in your requirements here.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="cWebcardPopupParagraph">
                  <img id="iFollowup" src=" https://dkzxkcjlbnjui.cloudfront.net/webcard/popup/icon/webcardpopupicon2.png" />
                  <p>Verified and top rated providers will contact you.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="cWebcardPopupParagraph">
                  <img id="iSelectProvider" src=" https://dkzxkcjlbnjui.cloudfront.net/webcard/popup/icon/webcardpopupicon3.png" />
                  <p>Get their quotes, compare, and select the one that meets your requirements.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="cWebcardPopupFootertext">
                  <h4>This is a free service.</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>
